import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-2EOCH6SN.mjs";
import "./chunk-ORCS5NZH.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
